module.exports = __webpack_public_path__ + "static/media/water-delivery-GIS-03.4acc6292.jpg";